import { Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { TopupAndWithdrawConst } from "../../../constants/TopUpAndWithdrawConst";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { Input } from "../../common/control/InputField";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/VipListAction";

export const VipGameBalance = ({ setSwalProps, setMemberid, memberid }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const [selectedNav, setSelectedNav] = useState(TopupAndWithdrawConst.TOPUP);

  const vipListState = useSelector(({ vipList }) => vipList, shallowEqual);

  const handleClose = () => setMemberid(undefined);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (memberid) {
      dispatch(
        actions.manageVipBalance({ action: "membervipbalance", memberid })
      );
    }
  }, [memberid]);

  const saveValues = (values) => {
    dispatch(
      actions.manageVipBalance({
        action:
          selectedNav === TopupAndWithdrawConst.TOPUP
            ? "membervipbalancetopup"
            : "membervipbalancewithdraw",
        ...values,
        memberid,
      })
    ).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        formikRef.current?.resetForm();
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({
            id:
              selectedNav === TopupAndWithdrawConst.TOPUP
                ? intl.formatMessage({ id: "topupSuccess" })
                : intl.formatMessage({ id: "withdrawSuccess" }),
          }),
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const validationSchema = Yup.object().shape({
    amount: Yup.string().required(
      intl.formatMessage({ id: "amountIsRequired" })
    ),
  });

  return (
    <Modal show={!!memberid} onHide={handleClose} centered data-bs-theme={mode}>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="d-flex">
            {Object.entries(TopupAndWithdrawConst).map(([key, value]) => (
              <h6
                style={{
                  color: selectedNav === value ? "#0080FF" : "",
                  borderBottom:
                    selectedNav === value ? "2px solid #0080FF" : "",
                  padding: "10px",
                  cursor: "pointer",
                }}
                className="text-font3"
                onClick={() => {
                  setSelectedNav(value);
                  formikRef.current?.resetForm();
                }}
                key={key}
              >
                {intl.formatMessage({ id: value })}
              </h6>
            ))}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center justify-content-end gap-1 border-bottom mb-1 pb-1">
          <div>{intl.formatMessage({ id: "balance" })}</div>
          <div>:</div>
          <div>{vipListState.vipBalance?.vipbalance}</div>
        </div>
        <Formik
          initialValues={{
            amount: "",
          }}
          validationSchema={validationSchema}
          innerRef={formikRef}
          onSubmit={(values) => saveValues(values)}
        >
          {({
            values,
            handleSubmit,
            setFieldValue,
            touched,
            errors,
            setFieldError,
          }) => (
            <Form>
              <label className="mb-2 text-input-label">
                {intl.formatMessage({ id: "amount" })}
              </label>
              <Field
                name="amount"
                component={Input}
                placeholder="0.00"
                autoComplete="off"
                type="number"
              />
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        {vipListState.actionsLoading && (
          <div
            className="spinner-border me-2"
            role="status"
            style={{ scale: "0.55" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        )}
        <button
          type="button"
          disabled={vipListState.actionsLoading}
          className="btn btn-primary px-3"
          onClick={() => formikRef.current?.submitForm()}
        >
          {selectedNav === TopupAndWithdrawConst.TOPUP
            ? intl.formatMessage({ id: "transferin" })
            : intl.formatMessage({ id: "transferout" })}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
